import { create } from "zustand";

interface SearchsStoreInterface {
  query: string;
  setQuery: (query: string) => void;
}

export const useSearchStore = create<SearchsStoreInterface>((set) => ({
  query: "",
  setQuery: (query) => set({ query }),
}));
